import React from 'react';
import PropTypes from 'prop-types';
import FlexSeparator from '@shared/helpers/flex-separator';
import Navigation from '@components/calendar/top-bar-navigation';
import View from '@components/calendar/top-bar-view';
import './top-bar.scss';

const TopBar = ({
  navNext, navPrevious, navToday, selectedDate,
  viewDay, viewWeek, viewMonth, selectedView
}) => (
  <div styleName="calendar-top-bar-container">
    <Navigation
      next={navNext}
      previous={navPrevious}
      today={navToday}
      selectedDate={selectedDate}
    />
    <FlexSeparator />
    <View
      day={viewDay}
      week={viewWeek}
      month={viewMonth}
      selected={selectedView}
    />
  </div>
);

TopBar.propTypes = {
  navNext: PropTypes.func,
  navPrevious: PropTypes.func,
  navToday: PropTypes.func,
  selectedDate: PropTypes.object,
  selectedView: PropTypes.string,
  viewDay: PropTypes.func,
  viewMonth: PropTypes.func,
  viewWeek: PropTypes.func
};

export default TopBar;
